document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.featured-collection_swiper').forEach(function (el) {
    var inner = el.closest('.featured-collection_inner');
    var fill  = inner.querySelector('.featured-collection_progress-fill');
    var prev  = inner.querySelector('.featured-collection_prev');
    var next  = inner.querySelector('.featured-collection_next');

    function updateProgress(swiper) {
      var progress = (swiper.activeIndex + 1) / swiper.slides.length;
      fill.style.width = (progress * 100) + '%';
    }

    var swiper = new Swiper(el, {
      slidesPerView: 3,
      spaceBetween: 26,
      breakpoints: {
        0: {
          slidesPerView: 1.19,
          spaceBetween: 16
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 26
        }
      },
      on: {
        init: function () { updateProgress(this); },
        slideChange: function () { updateProgress(this); }
      }
    });

    prev.addEventListener('click', function () { swiper.slidePrev(); });
    next.addEventListener('click', function () { swiper.slideNext(); });
  });
});
